import { Reducer } from "redux";
import {
    IToastSeverity,
    SHOW_TOAST_MESSAGE
} from "../actions/toastMessageActions";

export interface ToastMessageState {
    text: string;
    severity: IToastSeverity;
    link?: string;
    life: number;
    sticky: boolean;
    timestamp: number;
}

export const initialState: ToastMessageState = {
    text: "",
    severity: "success",
    link: undefined,
    life: 3000,
    sticky: false,
    timestamp: 0,
};

export const toastMessageReducer: Reducer<ToastMessageState> = (
    state: ToastMessageState = initialState,
    action: any
): ToastMessageState => {
    switch (action.type) {
        case SHOW_TOAST_MESSAGE:
            return {
                text: action.text,
                severity: action.severity,
                link: action.link,
                life: action.life,
                sticky: action.sticky,
                timestamp: Date.now(),
            };
        default:
            return state;
    }
};
